import { api } from "./api";

export async function GET_ALL_EVENTS(filters: any) : Promise<any[]>{
    const {data} = await api.get(`/events/search`, {params: filters})
    return data.events || [];
}